import React from 'react'
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts'
import styles from './MicrositeDeviceBreakdown.module.css'
import { Monitor, Smartphone, Tablet, HelpCircle } from 'lucide-react'

const DEVICE_META = {
    DESKTOP: { label: 'Desktop', color: '#0369a1', icon: Monitor },
    MOBILE:  { label: 'Mobile',  color: '#4a9fd8', icon: Smartphone },
    TABLET:  { label: 'Tablet',  color: '#9cc6e8', icon: Tablet },
    UNKNOWN: { label: 'Unknown', color: '#d7dade', icon: HelpCircle }
}

/**
 * MicrositeDeviceBreakdown
 * Pie chart showing visitor split across DESKTOP / MOBILE / TABLET
 * / UNKNOWN, used on MicrositeAnalytics.
 *
 * Usage:
 *   <MicrositeDeviceBreakdown data={deviceStats.data} />
 *   // data: [{ groupKey: 'MOBILE', totalViews: 320 }, ...]
 */
const MicrositeDeviceBreakdown = ({ data = [] }) => {
    const total = data.reduce((sum, d) => sum + (Number(d.totalViews) || 0), 0)

    if (!data.length || total === 0) {
        return <div className={styles.empty}>No device data yet</div>
    }

    const chartData = data.map((d) => ({
        name: DEVICE_META[d.groupKey]?.label || d.groupKey,
        value: Number(d.totalViews) || 0,
        color: DEVICE_META[d.groupKey]?.color || '#d7dade'
    }))

    return (
        <div className={styles.wrap}>
            <ResponsiveContainer width="100%" height={180}>
                <PieChart>
                    <Pie
                        data={chartData}
                        dataKey="value"
                        nameKey="name"
                        innerRadius={42}
                        outerRadius={64}
                        paddingAngle={2}
                    >
                        {chartData.map((entry, idx) => (
                            <Cell key={idx} fill={entry.color} stroke="none" />
                        ))}
                    </Pie>
                    <Tooltip
                        formatter={(value, name) => [`${value} views`, name]}
                        contentStyle={{ fontSize: 12, borderRadius: 6, border: '1px solid #e6e8eb' }}
                    />
                    <Legend
                        iconType="circle"
                        iconSize={8}
                        wrapperStyle={{ fontSize: 12, color: '#3a4150' }}
                    />
                </PieChart>
            </ResponsiveContainer>
        </div>
    )
}

export default MicrositeDeviceBreakdown